var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { mergeProps } from 'react-aria';
import { Dropdown } from '../dropdown';
import { Text } from '../text';
import Button from './button';
import { useToggleButton } from './context';
import { countStyle, listItemStyle } from './styles';
function renderCount(isActive, count) {
    return _jsx(Text, Object.assign({ css: countStyle({ isActive }) }, { children: count }));
}
export default function ItemInternal(_a, ref) {
    var { 'aria-label': ariaLabel, as, count, decor, hideLabel = false, id, label } = _a, restProps = __rest(_a, ['aria-label', "as", "count", "decor", "hideLabel", "id", "label"]);
    const { activeItem, firstButtonId, hasDividers, isDropdown, onChange } = useToggleButton();
    const typedRestProps = restProps;
    const isActive = activeItem != null ? activeItem === id : firstButtonId === id;
    const countEl = renderCount(isActive, count);
    function handleClick() {
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    }
    function renderButton() {
        const buttonEl = (_jsx(Button, Object.assign({}, mergeProps(typedRestProps, {
            'aria-label': ariaLabel,
            as,
            ref,
        }), Object.assign(Object.assign({}, (count != null && { count: countEl })), { decor,
            hideLabel,
            id,
            isActive }), { children: label })));
        return isDropdown ? (buttonEl) : (_jsx("li", Object.assign({}, (isActive && {
            'aria-current': true,
        }), { css: listItemStyle({ hasDividers }) }, { children: buttonEl })));
    }
    return isDropdown && !isActive ? (_jsx(Dropdown.Item, Object.assign({ as: as, label: label }, mergeProps(typedRestProps, Object.assign(Object.assign({ 'aria-label': ariaLabel, decorLeft: decor }, (count != null && { decorRight: countEl })), { isActive, onClick: handleClick })), { ref: ref }))) : (renderButton());
}
